const action = {
    general: 'An error occurred while running the action. Please try again later.',
    sign_in_identifier_changed: 'The action cannot change the sign-in identifier used for this verification.',
};
export default Object.freeze(action);
